<template>
    <Fragment>
        <div class="card mb-3">
            <div class="card-header d-flex flex-row">
                <h5 class="mr-auto">
                    <span v-show="project.isEditing == true">
                        <input v-model="project.label" class="form-control" />
                    </span>
                    <span v-show="!project.isEditing">
                        {{ project.label }}
                    </span>
                </h5>

                <project-actions-component
                    :editActions="true"
                    :project="project"
                ></project-actions-component>
            </div>
        </div>

        <!-- CONFIGURATIONS -->
        <div class="card mb-3">
            <div class="card-body">
                <configurations-component
                    :configurations="project.configurations"
                    :enableSelection="true"
                ></configurations-component>
            </div>
        </div>
    </Fragment>
</template>

<script>
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import configurationsComponent from "./configurations.vue"
import projectActionsComponent from "./projectActions.vue"

export default {
    name: 'projectsComponent',
    props: {
        project: {},
        isEditing: false
    },

    components: {
        Fragment,
        configurationsComponent,
        projectActionsComponent
    },
    data() {
        return {
            app: app
        }
    },
    methods: {
    }
}
</script>

<style>
</style>